export default __webpack_public_path__ + "static/media/video.0a44bc24.svg";